import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardStatisticsResponse, ApiResponse } from '../models/dashboard.models';
import { DashboardApiService, DashboardParams } from './dashboard-api.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private dashboardApiService: DashboardApiService) {}

  getDashboardStatistics(params: DashboardParams): Observable<ApiResponse<DashboardStatisticsResponse>> {
    return this.dashboardApiService.getDashboardStatistics(params);
  }
}